/**
 * Accordion.js — wires up [data-accordion] groups of .accordion-item panels.
 * Opening one item closes the others (single-open accordion behavior).
 */
export default class Accordion {
  constructor(selector = '[data-accordion]') {
    this.groups = document.querySelectorAll(selector);
    if (!this.groups.length) return;

    this.groups.forEach((group) => this._bindGroup(group));
  }

  _bindGroup(group) {
    const items = group.querySelectorAll('.accordion-item');

    items.forEach((item) => {
      const trigger = item.querySelector('.accordion-trigger');
      trigger?.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        items.forEach((i) => i.classList.remove('is-open'));
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }
}
